var _path, _path2, _circle, _path3, _path4, _path5, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSelectedMapHub(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 73,
    viewBox: "0 0 45 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.8304 41.9431C40.5113 38.0415 45 30.7949 45 22.5C45 10.0736 34.9264 0 22.5 0C10.0736 0 0 10.0736 0 22.5C0 30.793 4.48655 38.038 11.1648 41.9404C11.2861 42.1426 11.4082 42.3426 11.5312 42.5404C13.0078 44.9155 14.7129 47.3603 16.6465 49.875C18.5801 52.3897 19.916 54.0836 20.6543 54.9568C21.3926 55.83 22.0078 56.511 22.5 57L26.7188 52.1801C29.0893 49.4129 31.4599 46.0006 33.8304 41.9431Z",
    fill: "#00B483"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9095 23.5105C23.3771 24.4036 22.3455 25.0091 21.1603 25.0091C19.7878 25.0091 18.6213 24.1971 18.1974 23.0667L10.9285 30.3355C10.084 31.1801 10.1434 32.6087 11.0612 33.5265C11.979 34.4443 13.4076 34.5037 14.2522 33.6592L21.0969 26.8144L23.9457 29.6632C24.8635 30.581 26.2922 30.6404 27.1367 29.7959C27.9812 28.9514 27.9218 27.5228 27.004 26.605L24.1552 23.7561L23.9095 23.5105Z",
    fill: "#00B483"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 22.5,
    r: 18.5,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9946 23.6272C23.4762 24.4968 22.4718 25.0864 21.3177 25.0864C19.9813 25.0864 18.8456 24.2957 18.4328 23.1951L11.3552 30.2727C10.5329 31.095 10.5907 32.486 11.4844 33.3797C12.378 34.2733 13.7691 34.3311 14.5914 33.5088L14.5924 33.5079L21.256 26.8442L24.0299 29.6181C24.9235 30.5117 26.3146 30.5696 27.1369 29.7473C27.9592 28.925 27.9013 27.5339 27.0077 26.6403L27.0061 26.6387L24.2338 23.8664L23.9946 23.6272Z",
    fill: "#00B483"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.7751 32.1794C31.6607 33.0651 33.1056 33.0561 34.0024 32.1593C34.8991 31.2626 34.9081 29.8177 34.0225 28.932L26.8445 21.754L29.6126 18.9859L29.6281 18.9706C30.5248 18.0739 30.5338 16.629 29.6482 15.7433C28.7626 14.8577 27.3177 14.8667 26.4209 15.7635L26.4209 15.7635L26.4208 15.7634L22.709 19.4752C23.6548 19.9898 24.2956 20.9838 24.2956 22.1255C24.2956 23.0971 23.8316 23.9617 23.1105 24.5149L30.7751 32.1794Z",
    fill: "#00684B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.0482 12.4121C32.9434 11.5169 32.9509 10.0728 32.0648 9.18679C31.1788 8.30074 29.7347 8.30819 28.8395 9.20344L21.5836 16.4593L18.8333 13.709C17.9473 12.823 16.5032 12.8304 15.608 13.7257C14.7127 14.6209 14.7053 16.0649 15.5913 16.951L18.3416 19.7013L19.0423 20.4019C19.5949 19.6683 20.4683 19.1947 21.4511 19.1947C22.4847 19.1947 23.3971 19.7184 23.9428 20.5175L32.0482 12.4121Z",
    fill: "#21343B"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_648_74192)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 64,
    r: 5,
    fill: "#00B483"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_648_74192",
    x: 14.5,
    y: 57,
    width: 16,
    height: 16,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_648_74192"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_648_74192",
    result: "effect2_dropShadow_648_74192"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_648_74192",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedMapHub);
export default __webpack_public_path__ + "static/media/selected-map-hub.225b935480b578d30a4cc923abd40634.svg";
export { ForwardRef as ReactComponent };